// extracted by mini-css-extract-plugin
module.exports = {"signUpForm":"SignUpForm--signUpForm--1dhcG","signUpForm__label":"SignUpForm--signUpForm__label--14S-8","placeholderAnim":"SignUpForm--placeholderAnim--1UEEB"};